import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { Member } from '../types';
import { CompliancePackageData } from '../types/compliance';
import { CurrentPlanDetails } from '../types/plan';
import { getOrganizationCompliancePackagesData } from './complianceConfigurations';
import { getSubscriptionData } from './subscription';
import { getMembersList } from './organizationInformation';

interface UpgradeToAdvancedSubscriptionResponse {
    subscriptionId: string;
    paymentUrl: string;
}

export const upgradeToAdvanced = async (redirectUrl?: string): Promise<UpgradeToAdvancedSubscriptionResponse> => {
    try {
        const response = await axios.put<UpgradeToAdvancedSubscriptionResponse>(
            pathfinder(
                'pro_tier_update_subscription',
                undefined,
                redirectUrl ? { query: { redirect_url: redirectUrl } } : undefined
            ),
            {
                action: 'upgrade_to_advanced',
            }
        );
        return response.data;
    } catch (error) {
        logger.error(error as Error, { description: 'Failed to upgrade to advanced subscription' });
        throw error;
    }
};

export const sendUpgradeRequest = (note?: string) => {
    try {
        const url = pathfinder('pro_tier_upgrade_request');
        return axios.post(url, { note });
    } catch (e) {
        logger.error(e as Error, { description: 'Failed to send upgrade request' });
        throw e;
    }
};

export interface UpgradeStepData {
    members: Member[];
    compliancePackageData: CompliancePackageData;
    subscriptionData: CurrentPlanDetails;
}

export const initializeUpgradeStepData = async (): Promise<UpgradeStepData> => {
    const [members, compliancePackageData, subscriptionData] = await Promise.all([
        getMembersList({ includeSelf: true }),
        getOrganizationCompliancePackagesData(),
        getSubscriptionData(),
    ]);

    return {
        members,
        compliancePackageData,
        subscriptionData,
    };
};
